import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const palette = [
  "#4E79A7", "#F28E2B", "#E15759", "#76B7B2",
  "#59A14F", "#EDC948", "#B07AA1", "#FF9DA7",
  "#9C755F", "#BAB0AC"
];

const PieChartDuplo = ({ data, chartLabel }) => {
  
  // Função de processamento de dados mantida (lógica de agrupar < 5% em "Outras")
  const processData = (dataSet) => {
    // Validação para evitar erro em array vazio
    if (!dataSet || dataSet.length === 0) return [];

    let total = dataSet.reduce((sum, item) => sum + item.value, 0);
    if (total === 0) return []; // Evita divisão por zero

    let othersValue = 0;
    let othersCount = 0;
    let uniqueOther;
    
    const processedData = dataSet.reduce((acc, item) => {
      const percentage = (item.value / total) * 100;
      if (percentage < 5) {
        othersValue += item.value;
        uniqueOther = item;
        othersCount++;
      } else {
        acc.push(item);
      }
      return acc;
    }, []);

    if (othersValue > 0) {
      if (othersCount === 1) {
        processedData.push(uniqueOther);
      } else {
        processedData.push({ name: 'Outras', value: othersValue });
      }
    }
    return processedData;
  };

  const dataEntradas = processData(data.chartDataEntradas.map(item => ({
    name: item.DESCRICAO,
    value: parseFloat(item.VALOR.replace(/\./g, '').replace(',', '.'))
  })));
  
  const dataSaidas = processData(data.chartDataSaidas.map(item => ({
    name: item.DESCRICAO,
    value: parseFloat(item.VALOR.replace(/\./g, '').replace(',', '.')) * -1
  })));

  const CustomLegend = ({ payload }) => {
    if (!payload) return null;
  
    return (
      <div className="container no-margin mt-3">
        <div className="row justify-content-center">
          {payload.map((entry, index) => (
            <div key={`item-${index}`} className="col-6 col-md-4 d-flex align-items-center mb-2">
              <div 
                className="rounded-circle shadow-sm"
                style={{
                  minWidth: '12px',
                  height: '12px',
                  backgroundColor: entry.color,
                  marginRight: '6px',
                }}
              />
              <span className="text-muted small fw-bold text-truncate" title={entry.value}>
                {entry.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };  

  // Configuração comum para ambos os gráficos
  const renderPieChart = (dataSet, title) => (
    <div className="col-12 col-lg-6 d-flex flex-column align-items-center mb-4 mb-lg-0">
      <h5 className="text-center text-secondary fw-bold mb-3">{title}</h5>
      
      <div style={{ width: '100%', height: 400 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart margin={{ top: 0, right: 30, left: 30, bottom: 0 }}>
            <Pie 
              data={dataSet} 
              cx="50%" 
              cy="50%" 
              labelLine={true} 
              outerRadius="70%" 
              innerRadius="40%"
              dataKey="value"
              paddingAngle={2} // Espacinho entre as fatias
              label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
              isAnimationActive={true}
            >
              {dataSet.map((entry, index) => (
                <Cell 
                  key={`cell-${index}`} 
                  fill={palette[index % palette.length]} 
                  stroke="#fff"
                  strokeWidth={2}
                />
              ))}
            </Pie>
            <Tooltip 
              formatter={(value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)}
              contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
            />
            <Legend content={<CustomLegend />} verticalAlign="bottom" align="center" />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );

  return (
    <div className="container-fluid px-0">
      <div className="row">
        {/* Renderiza apenas se houver dados, senão mostra aviso */}
        {dataEntradas.length > 0 ? renderPieChart(dataEntradas, chartLabel[0]) : (
           <div className="col-12 col-lg-6 text-center text-muted p-5">Sem dados de entrada</div>
        )}
        
        {dataSaidas.length > 0 ? renderPieChart(dataSaidas, chartLabel[1]) : (
           <div className="col-12 col-lg-6 text-center text-muted p-5">Sem dados de saída</div>
        )}
      </div>
    </div>
  );
};

export default PieChartDuplo;